import { render, staticRenderFns } from "./AircrewTransfer.vue?vue&type=template&id=b2dbce4e&"
import script from "./AircrewTransfer.vue?vue&type=script&lang=ts&"
export * from "./AircrewTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports